import { FunctionComponent } from 'react'
import { Chip } from '@black-bear-energy/rucksack'

export const FilterChip: FunctionComponent<FilterChipProps> = ({
  label,
  onDelete,
}) => {
  return (
    <Chip
      size="small"
      label={label}
      onDelete={onDelete}
      sx={{ fontWeight: '600' }}
    />
  )
}

interface FilterChipProps {
  label: string
  onDelete: () => void
}
